<template>
  <div class="container" >
      <iframe ref="myIframe" scrolling="no" frameborder="0" style="width: 100%; height: 100%;" src="/html/linianwenhua.html"></iframe>
  </div>
</template>

<script>
  import {getEnterpriseList} from "../../../api/zoujindaweijia"

  export default {
    name: "Li",
    data(){
      return{
        data:[]
      }
    },
    methods:{
      sendMessageToIframe: function(data){
          const iframe = this.$refs.myIframe;
          // 使用 postMessage 发送数据给 iframe
          iframe.contentWindow.postMessage(data, "*");
      }
    },
    mounted() {
      getEnterpriseList().then(res=>{
        let data = res.data[1];
        this.data = data;
        this.sendMessageToIframe(data)
      })

    }
  }
</script>

<style scoped>
  .container{
    /* width: 100%; */
    margin-top: 0.1042vw;
    margin-bottom: 7vw;
    text-align: center;
    height: 30.8646vw !important;
    padding: 0 23vw !important;
  }
.div1{
margin-bottom: 1.5417vw;
  font-size: 1.5458vw;
  font-weight: 600;
}
  .div2{
    margin-bottom: 1.2208vw;
    font-size: 1.0333vw;

  }
  .div3{
    margin-bottom: 2.3625vw;
    font-size: 1.0333vw;
  }
  span{
    font-weight: 600;
  }

</style>